export default function redBanner(options = {}) {
	var alertEl = document.querySelector('.red-banner');
	var navEl = document.getElementById('primary-navigation');

	if (!alertEl || !navEl) {
		return;
	}

	function updateOffsets() {
		var alertHeight = alertEl.offsetHeight || 0;
		var navHeight = navEl.offsetHeight;
		var totalOffset = navHeight + alertHeight;

		// Push nav down by alert height.
		document.documentElement.style.setProperty(
			'--alert-offset',
			alertHeight + 'px'
		);

		// Make main spacer match nav + alert.
		document.documentElement.style.setProperty(
			'--top-offset',
			totalOffset + 'px'
		);

		console.log(
			'Updated offsets — alert: ' +
				alertHeight +
				'px, total: ' +
				totalOffset +
				'px'
		);
	}

	// Initial calculation.
	updateOffsets();

	// Recalculate on resize.
	window.addEventListener('resize', updateOffsets);

	// Handle late-loading fonts.
	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(updateOffsets);
	}

	// Dismiss functionality.
	var dismissBtn = alertEl.querySelector('.red-banner__dismiss');
	if (dismissBtn) {
		dismissBtn.addEventListener('click', function (e) {
			e.preventDefault();

			alertEl.style.display = 'none';

			// Reset offsets.
			document.documentElement.style.setProperty(
				'--alert-offset',
				'0px'
			);

			document.documentElement.style.setProperty(
				'--top-offset',
				navEl.offsetHeight + 'px'
			);

			console.log('Red banner dismissed, offsets reset.');
		});
	}
}
